export default {
  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  },
  
  selectOption(minutes) {
    this.$store.dispatch('interviewState/setInterviewDuration',minutes)
    this.duration = `${minutes}分钟`
    this.closeDropdown()
  },
  
  // 用于点击外部关闭下拉菜单
  closeDropdown() {
    if (this.dropdownVisible) {
      this.dropdownVisible = false;
    }
  },
    // 用于点击外部关闭下拉菜单
  closeDropdown() {
    if (this.dropdownVisible) {
      this.dropdownVisible = false;
    }
  },

  // 切换语言选择下拉菜单的可见性
  toggleLanguageDropdown() {
    this.languageDropdownVisible = !this.languageDropdownVisible;
  },

  // 选择具体的语言选项
  selectLanguage(value) {
          if(value == 1){
        this.language = '中文'
      }else if(value == 2){
        this.language = '英语'
      }else if(value == 3){
        this.language = '日语'
      }else if(value == 4){
        this.language = '西班牙语'
      }
    this.$store.dispatch('interviewState/setInterviewLanguage', value); // 新增的代码
    this.languageDropdownVisible = false;
  },

  // 关闭语言选择下拉菜单
  closeLanguageDropdown() {
    if (this.languageDropdownVisible) {
      this.languageDropdownVisible = false;
    }
  }
}; 